import { render, staticRenderFns } from "./LayoutFormBusiness.vue?vue&type=template&id=e135751e&"
import script from "./LayoutFormBusiness.vue?vue&type=script&lang=js&"
export * from "./LayoutFormBusiness.vue?vue&type=script&lang=js&"
import style0 from "./LayoutFormBusiness.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports